<div class="script-card" (click)="goToScript()">
  <div class="medication-name">{{ script().medicationName }}</div>
  <div class="details">
    <div class="detail-row">
      <div class="prop">Name</div>
      <div class="prop-value">{{ script().electronPrescriptionFor }}</div>
    </div>
    <div class="detail-row">
      <div class="prop">Prescription date</div>
      <div class="prop-value">{{ script().prescriptionDate | date: 'dd MMM yyyy' }}</div>
    </div>
    <div class="detail-row">
      <div class="prop">Supply remaining</div>
      <div class="prop-value">{{ script().supplyRemaining }}</div>
    </div>
    <div class="detail-row">
      <div class="prop">Status</div>
      <div class="prop-value">
        <div class="status-tag" [ngClass]="status().class">{{ status().label }}</div>
      </div>
    </div>
  </div>
</div>